// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card__title[data-v-049017a8] {\n  word-break: normal;\n}\n.v-card[data-v-049017a8] {\n  cursor: pointer;\n}\n.featured-folder-icon[data-v-049017a8] {\n  font-size: 215px !important;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
